
<Detail v-if="data" :logo-on-click="logoOnClick" show-footer>
    <template v-slot:header>
        <div class="row">
            <div class="col col-6">
                <h4>{{ $t("buyer") }}</h4>
                <h2>{{ data.name }}</h2>
                <h3>{{ $t("organization_id") | upper }}: {{ data.ico }}</h3>
            </div>
            <div id="suppliers" class="col col-2 d-none d-md-block ">
                <h4>{{ $tc("supplier", 2) }}</h4>
                <h2 class="numeric">
                    {{ formatInteger(data.suppliers_count) }}
                </h2>
            </div>
            <div id="period" class="col col-6 col-md-4">
                <h4>{{ $t("period") }}</h4>
                <h2 class="numeric">
                    {{ data.start_date | moment("M/YYYY") }}-{{ data.end_date | moment("M/YYYY") }}
                </h2>
            </div>
        </div>
    </template>

    <template v-slot:header_small>
        <div class="row no-gutters">
            <div class="col col-6 col-md-8">
                <h2>{{ data.name }}</h2>
            </div>
            <div id="period" class="col col-6 col-md-4">
                <h2 class="numeric">
                    {{ data.start_date | moment("M/YYYY") }}-{{
                        data.end_date | moment("M/YYYY")
                    }}
                </h2>
            </div>
        </div>
    </template>

    <template v-slot:menu>
        <teaser-ad :name="data.name" :ico="data.ico" :flags-total="data.flags_total"></teaser-ad>
    </template>

    <template v-slot:content>

        <color-bubble variant="dark" ratio="half">
            <template v-slot:icon>
                <b-icon-wallet />
            </template>
            <template v-slot:heading>{{ $t("overview.sum.short", [formatNumber(data.suppliers_total)]) }}</template>
            <template v-slot:description>{{ $t("overview.sum.long") }}</template>
        </color-bubble>



        <color-bubble variant="beige"
            @click.native="goToBlog()"
            class="clickable-color-bubble d-none d-md-block color_dark_important"
        >
            <template v-slot:icon>
                <b-icon-newspaper></b-icon-newspaper>
            </template>
            <template v-slot:heading>Co Kontrola umí a k čemu je dobrá?</template>
            <template v-slot:description>
                Blog&nbsp;
                <img :src="`${publicPath}double_arrow.svg`">
            </template>
        </color-bubble>


         <color-bubble variant="beige"
            @click.native="order(data.name, data.ico, 'lite')"
            class="clickable-color-bubble d-none d-md-block color_dark_important"
        >
            <template v-slot:icon>
                <b-icon-search></b-icon-search>
            </template>
            <template v-slot:heading>{{ $t("overview.flags.other") }}</template>
            <template v-slot:description>
                {{ $t("button.order") }}&nbsp;
                <img :src="`${publicPath}double_arrow.svg`">

            </template>

        </color-bubble>

        <h5 class="mt-5 mb-3" id="flags_carousel_section">
            {{ $t("overview.carousel.title") }}
        </h5>

        <b-carousel id="flags-carousel"
            :interval="10000"
            indicators
            controls
            v-model="activeCarouselSlide"
            @slide-start="carouselDescriptionExpanded = false"
        >
            <b-carousel-slide v-for="(f, i) in data.carousel" :key="`carousel-slide-${f.id}`" :caption="null">
                <div class="row align-items-center no-gutters">
                    <div class="col carousel-slide-content align-items-center"
                        :class="{expanded: carouselDescriptionExpanded, long: longDescriptions.includes(i)}"
                    >
                        <div class="row align-items-center h-100">
                            <div class="col">
                                <div class="row">
                                    <div class="col col-sm-auto">
                                        <RiskLevelDumpling :value="f.risk" :level="versionRiskLevel(f, version)" />
                                    </div>
                                    <div class="col">
                                        <span class="carousel-header"><strong>{{ f.type }}</strong> > {{ f.group }}</span>
                                        <br/>
                                        <div class="carousel-description">
                                            {{ f.desc }}
                                            <a href="javascript:void(0)" @click="carouselDescriptionExpanded = !carouselDescriptionExpanded">
                                                <template v-if="carouselDescriptionExpanded">{{$t("overview.carousel.collapse")}}</template>
                                                <template v-else>{{$t("overview.carousel.expand")}}</template>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-carousel-slide>
        </b-carousel>

        <h5 class="mt-5 mb-3" id="flags_section">
            {{ $t("overview.flags.title") }}
        </h5>

        <RisksTable :flags="data.flags" :version="version" />



        <teaser-ad class="d-md-none" :name="data.name" :ico="data.ico" :flags-total="data.flags_total"></teaser-ad>
    </template>
</Detail>
